import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { GbeEndPointV4 } from '@core/models/gbe/gbe-endpoint.enum';

import { GBE_BASE_URL } from '../../tokens/gbe-url.token';

export interface FetchAllSolversResponse {
  id: number;
  name: string;
  description?: string;
  createdAt: Date;
  solver: string; //Delete after backend is fixed
  dataSpaceId: number;
  totalParams: number;
}

export interface FetchSolverByIdResponse {
  id: number;
  name: string;
  description?: string;
  createdAt: Date;
  solver: string; //Delete after backend is fixed
  totalParams: number;
  dataSpaceId: number;
  orchestrator: {
    uid: string;
    major_version: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class SolverService {
  private readonly http = inject(HttpClient);
  private readonly gbeUrl = inject(GBE_BASE_URL);

  private buildUrl(endpoint: string): string {
    return `${this.gbeUrl}/${endpoint}`;
  }
  public getSolverList$(dataSpaceId?: number): Observable<FetchAllSolversResponse[]> {
    const url = this.buildUrl(GbeEndPointV4.SOLVERS);
    return this.http.get<FetchAllSolversResponse[]>(url, {
      params: {
        ...(dataSpaceId ? { dataSpaceId: dataSpaceId.toString() } : {})
      }
    });
  }

  public getSolverById$(solverId: number): Observable<FetchSolverByIdResponse> {
    const url = this.buildUrl(`${GbeEndPointV4.SOLVERS}/${solverId}`);
    return this.http.get<FetchSolverByIdResponse>(url);
  }
}
